<template>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
        ServerSide
      <vue-good-table
      mode="remote"
    @on-page-change="onPageChange"
    @on-sort-change="onSortChange"
    @on-column-filter="onColumnFilter"
    @on-per-page-change="onPerPageChange"
    :search-options="{enabled: true, placeholder: 'სახელი და გვარი'}"
    :totalRows="totalRecords"
    :pagination-options="{
                                    enabled: true,
                                    mode: 'records',
                                    perPage: 5,
                                    position: 'top',
                                    perPageDropdown: [10, 15, 25, 50],
                                    dropdownAllowAll: false,
                                    setCurrentPage: 1,
                                    nextLabel: 'შემდეგი',
                                    prevLabel: 'წინა',
                                    rowsPerPageLabel: 'ნაჩვენები ჩანაწერების რაოდენობა',
                                    ofLabel: '-ჩანაწერი სულ',
                                    pageLabel: 'გვერდი', // for 'pages' mode
                                    allLabel: 'ყველა',
                                  }"
      :columns="RequestsTablecolumns"
      :rows="RequestsTablerows"
      >
      <div slot="table-actions">
              <!-- <button class="btn btn-link e-mtavr-17 btn-outline-secondary" @click="filterToggle()">
                <i class="lnr lnr-funnel mr-2"></i> ფილტრები
              </button> -->
              <!-- <button class="btn btn-link e-mtavr-17 btn-outline-secondary" v-b-modal.excelImportModal>
                <i class="lnr lnr-download mr-2"></i> ექსელიდან იმპორტი
              </button> -->
              <!-- <b-button v-b-modal.addRequestModal>Show Modal</b-button> -->
              <button class="btn btn-link e-mtavr-17 btn-outline-secondary" @click="exportToExcel()">
                <i class="lnr lnr-upload mr-2"></i> ექსელში ექსპორტი
              </button>
              <!-- <download-excel class="btn btn-link e-mtavr-17 btn-outline-purple"
    :data   = "json_data">
   <i class="fas fa-file-export mr-2"></i> ექსელში ექსპორტი
              </download-excel>-->
              <b-button
                class="btn btn-link e-mtavr-17 btn-outline-secondary mr-2"
                v-b-modal.addRequestModal
              >
                <i class="lnr lnr-file-add mr-2"></i> ახალი მოთხოვნა
              </b-button>
            </div>
            <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field == 'ScrStatus'">
                <div
                  v-if="props.row.matchCount > 0"
                  class="badge badge-danger e-nusx-8"
                >საყურადღებო</div>
                <div v-else class="badge badge-success e-nusx-8">არცერთი დამთხვევა</div>
              </div>
              <!-- <div v-else-if="props.column.field == 'functions'" class="e-whitespace-nowrap">
                <button
                  class="btn btn-info icon-btn btn-sm"
                  title="სკანირების რეზულტატების ნახვა"
                  v-if="props.row.matchCount > 0"
                >
                  <span class="lnr lnr-magnifier"></span>
                </button>
              </div> -->
            </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import BaseService from '@/backend/vue-axios/axios.js'
import moment from 'moment'
export default {
  name: 'registeredRequests',
  metaInfo: {
    title: ' - ყველა მოთხოვნა'
  },
  data () {
    return {
      header: {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      },
      RequestsTablecolumns: [

        {
          label: '#',
          type: 'number',
          thClass: 'e-ts-12',
          tdClass: 'e-ts-12',
          field: 'id'
        },
        {
          label: 'სქრინინგ სტატუსი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'ScrStatus',
          filterOptions: {
            placeholder: 'ყველა',
            filterDropdownItems: [
              { value: '0', text: 'არცერთი დამთხვევა' },
              { value: 'x', text: 'საყურადღებო' }
            ],
            // filterDropdownItems: ['არცერთი დამთხვევა', 'საყურადღებო'],
            enabled: true
          }
        },
        {
          label: 'მოთხოვნის სტატუსი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'statusText',
          filterOptions: {
            placeholder: 'ყველა',
            filterDropdownItems: ['დაუმუშავებელი', 'მუშავდება', 'დადასტურებული', 'დაბლოკილი'],
            enabled: true
          }
        },
        {
          label: 'დამთხვევის %',
          field: 'matchPercent',
          thClass: 'e-mtavr-17 e-ts-08rem e-whitespace-nowrap',
          tdClass: 'text-center',
          type: 'number',
          filterOptions: {
            placeholder: 'ციფრი',
            enabled: true
          }
        },
        {
          label: 'საძიებო ტექსტი',
          html: true,
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'SearchedCriteria',
          filterOptions: {
            placeholder: 'სახელი და გვარი',
            enabled: true
          }
        },
        {
          label: 'მისამართი',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          html: true,
          field: 'FullAddress'
        },
        {
          label: 'იდენტიფიკატორი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12',
          field: 'personalN'
        },
        {
          label: 'მოთხოვნის დრო',
          type: 'dateTime',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'recDate',
          formatFn: function (value) {
            if (value != null) {
              return moment(value).format('DD.MM.YYYY HH:mm:SS')
            }
            return 'თარიღი ცარიელია'
          }
        },
        {
          label: 'ტრანზაქციის ID',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          field: 'requestUniqueId'
        },
        {
          label: 'ბოლო კომენტარი',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12',
          html: true,
          field: 'LastCommentItem'
        },
        {
          label: 'დამუშავების დაწყების დრო',
          type: 'dateTime',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12 e-nusx-8',
          field: 'investigationStartDate',
          formatFn: function (value) {
            if (value != null) {
              return moment(value).format('DD.MM.YYYY HH:mm:SS')
            }
            return 'თარიღი ცარიელია'
          }
        },
        {
          label: 'გადაწყვეტილების მიღების დრო',
          type: 'datetime',
          thClass: 'e-mtavr-17 e-ts-12 e-whitespace-nowrap',
          tdClass: 'e-ts-12 e-nusx-8',
          field: 'statusChangeDate',
          formatFn: function (value) {
            if (value != null) {
              return moment(value).format('DD.MM.YYYY HH:mm:SS')
            }
            return 'თარიღი ცარიელია'
          }
        },
        {
          label: 'მომხმარებელი',
          type: 'text',
          thClass: 'e-mtavr-17 e-ts-12',
          tdClass: 'e-ts-12 e-nusx-8',
          field: 'LastActionUser'
        }
        // {
        //   label: 'ფუნქციები',
        //   field: 'functions',
        //   thClass: 'e-mtavr-17 e-ts-12',
        //   tdClass: 'e-ts-12'
        // }
      ],
      RequestsTablerows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 5
      }
    }
  },
  methods: {
    updateParams (newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps)
    },

    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },

    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },

    onSortChange (params) {
      let sort = []
      sort = params
      this.updateParams({
        sort
        // sort: [
        //   {
        //     type: params.sortType,
        //     // field: this.RequestsTablecolumns[params.columnIndex].field
        //     field: params
        //   }
        // ]
      })
      this.loadItems()
    },

    onColumnFilter (params) {
      if (params.columnFilters.matchCount) {
        params.columnFilters.matchCount = params.columnFilters.ScrStatus
        delete params.columnFilters.ScrStatus // no warning
      }
      if (params.columnFilters.matchPercent) {
        params.columnFilters.matchPercent = parseInt(params.columnFilters.matchPercent)
      }
      console.log(params)
      this.updateParams(params)
      this.loadItems()
    },

    // load items is what brings back the rows from server
    loadItems () {
      BaseService.GetRequestsServerSide(this.header, this.serverParams)
        .then(res => {
          // console.log(res)
          if (res.data.success) {
            for (var i = 0, len = res.data.result.requests.length; i < len; i++) {
              res.data.result.requests[i].brthDate === null ? res.data.result.requests[i].brthDate = null : res.data.result.requests[i].brthDate = moment(res.data.result.requests[i].brthDate).format('DD.MM.YYYY')
              res.data.result.requests[i].SearchedCriteria = 'სახელი და გვარი / დასახელება: <strong>' + res.data.result.requests[i].firstName + ' ' + res.data.result.requests[i].lastName + '</strong></br> დაბადების თარიღი: <strong>' + res.data.result.requests[i].brthDate + '</strong>'
              res.data.result.requests[i].FullAddress = 'ქვეყანა: <strong>' + res.data.result.requests[i].country + '</strong></br> მისამართი: <strong>' + res.data.result.requests[i].address + '</strong>'
              res.data.result.requests[i].LastCommentItem = 'კომენტარი: <strong>' + res.data.result.requests[i].commentText + '</strong></br> ავტორი: <strong>' + (res.data.result.requests[i].commentUserName == null ? 'ავტორი არ არის ცნობილი' : res.data.result.requests[i].commentUserName) + '</strong>'
              res.data.result.requests[i].LastActionUser = res.data.result.requests[i].userFirstName + ' ' + res.data.result.requests[i].userLastName
            }
            this.RequestsTablerows = res.data.result.requests
            this.totalRecords = res.data.result.totalNumber
          }
        })
      // console.log(this.serverParams)
    //   getFromServer(this.serverParams).then((res) => {
    //     this.totalRecords = res.totalRecords
    //     this.rows = res.rows
    //   })
    }
  }
}
</script>

<style>
</style>
